module.exports = __webpack_public_path__ + "icon_email-738c89662d6640f5e6539151023d049a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_email.png
// module id = 271
// module chunks = 76